import React from 'react';
import {Link} from 'react-router-dom';

class Section extends React.Component {

    constructor(props) {
        super(props);

        this.onTabClick =  this.onTabClick.bind(this);
        this.onTitleClick =  this.onTitleClick.bind(this);
        this.onIconClick =  this.onIconClick.bind(this);
    }

    onTabClick(event) {
        this.props.onTabClick(event.target.parentElement.getAttribute('id'));
    }

    onTitleClick(event) {
        this.props.onTitleClick(event.target.parentElement.parentElement.getAttribute('id'));
    }
    onIconClick(event) {
        this.props.onIconClick(event.target.parentElement.parentElement.getAttribute('id'));
    }

    render() {
        let {
            id,
            iconClassName,
            title,
            active,
        } = this.props;

        const elemClassName = active ? 'nav-active' : '';

        return (
            <li id={id} className={`has_sub ${elemClassName}`}
                onClick={event => this.onTabClick(event)}>
                <a href="javascript:void(0);" className="waves-effect"><i className={iconClassName} onClick={event => this.onIconClick(event)}></i>
                    <span onClick={event => this.onTitleClick(event)}>{title}</span>
                </a>

                <ul className="list-unstyled">
                    {this.props.children}
                </ul>
            </li>
        );
    };
}

export default Section;




// WEBPACK FOOTER //
// ./web/src/components/navigation/Section.jsx